export default __webpack_public_path__ + "static/media/Close_Button.9f23bf0c.svg";